import { Doughnut } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import exportAllExports from "./Export/exportAllExports";
import {
  useGetUserRegistrationsFullQuery,
  useGetUsersPerCountryQuery,
} from "../../services/API/statisticsAPI";
import ChartCard from "./ChartCard";
import CsvDownloadButton from "./CsvDownloadButton";
import { baseOptions, colorAt, REST_COLOR } from "./chartTheme";

const UsersPerCountryStats = () => {
  const { t } = useTranslation(["translation", "statistics"]);
  const MAX_COUNTRIES = 10;
  const { data: countries } = useGetUsersPerCountryQuery(undefined, {
    pollingInterval: 60000,
  });
  const { data: userRegistrationsFullData } = useGetUserRegistrationsFullQuery(undefined, {
    pollingInterval: 60000,
  });

  let countriesFiltered = [];

  if (countries) {
    let tempCountries = [...countries];
    let rest = 0;

    tempCountries.sort((i1, i2) => {
      if (i1.count === i2.count) {
        return 0;
      }
      return i1.count - i2.count < 0 ? 1 : -1;
    });

    tempCountries.map((item) => {
      if (countriesFiltered.length < MAX_COUNTRIES) {
        countriesFiltered.push(item);
      } else {
        rest += item.count;
      }
      return null;
    });
    countriesFiltered.push({ _id: { country: "Rest" }, count: rest });
  }

  // No data: render a gray placeholder slice instead of a blank area
  const hasData = countriesFiltered.some((item) => item.count > 0);

  const usersPerCountryData = hasData
    ? {
        labels: countriesFiltered?.map((item) => `${item._id.country} – ${item.count}`),
        datasets: [
          {
            label: t("user.Number of Users", { ns: "statistics" }),
            data: countriesFiltered?.map((item) => item.count),
            backgroundColor: countriesFiltered?.map((item, index) =>
              item._id.country === "Rest" ? REST_COLOR : colorAt(index)
            ),
            borderColor: "#ffffff",
            borderWidth: 2,
            hoverOffset: 6,
          },
        ],
      }
    : {
        labels: [t("general.no_data", { ns: "statistics" })],
        datasets: [
          {
            label: t("user.Number of Users", { ns: "statistics" }),
            data: [1],
            backgroundColor: [REST_COLOR],
            borderColor: "#ffffff",
            borderWidth: 2,
          },
        ],
      };

  const base = baseOptions();
  const options = {
    ...base,
    cutout: "55%",
    plugins: {
      ...base.plugins,
      legend: {
        ...base.plugins.legend,
        position: "right",
      },
      tooltip: {
        ...base.plugins.tooltip,
        enabled: hasData,
      },
    },
  };

  return (
    <ChartCard
      title={t("user.Nutzer nach Länder", { ns: "statistics" })}
      action={
        <CsvDownloadButton
          data={exportAllExports?.exportRegistrationsFull(userRegistrationsFullData ?? [])}
          headers={exportAllExports.headersRegistrationsFull()}
          filename={"stats_countries_full.csv"}
        />
      }
    >
      <Doughnut data={usersPerCountryData} options={options} />
    </ChartCard>
  );
};

export default UsersPerCountryStats;
